const API_URL = process.env.REACT_APP_API_URL + "auth/user/signup";

export const FetchCreateUser = async (data) => {
  const token = localStorage.getItem("token");
  console.log("SENDING THIS:", data)

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    const responseData = await response.json();

    if (!response.ok) {
      console.warn("[FetchCreateAdmin] Request failed:", response.status, responseData);
      return {
        status: response.status,
        error: responseData?.message || "Ein Fehler ist aufgetreten",
      };
    }

    return {
      status: response.status,
      data: responseData,
    };

  } catch (error) {
    console.error("[FetchCreateAdmin] Network error:", error);
    return {
      status: 500,
      error: "Netzwerkfehler – bitte versuchen Sie es später erneut",
    };
  }
};
